/**
 * Reusable pseudo-3D gradient icon orb.
 * @param {React.ElementType} icon  lucide icon component
 * @param {string} size  tailwind size classes for the wrapper, default "h-12 w-12"
 * @param {string} iconSize  tailwind size for the icon, default "w-6 h-6"
 */
export default function Icon3D({
  icon: Icon,
  size = "h-12 w-12",
  iconSize = "w-6 h-6",
  className = "",
}) {
  return (
    <span className={`icon-3d ${size} ${className}`}>
      {Icon ? <Icon className={`${iconSize} relative z-10`} /> : null}
    </span>
  );
}
